const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    currency: 'Currency',
    amount: 'Amount',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    firstName: 'First Name',
    firstNamePlaceholder: 'Firstname',
    lastName: 'Last Name',
    lastNamePlaceholder: 'LastName',
    country: 'Country',
    countryPlaceholder: 'Country',
    state: 'State',
    statePlaceholder: 'State',
    city: 'City',
    cityPlaceholder: 'City',
    address: 'Address',
    addressPlaceholder: 'Address',
    zipCode: 'Zip Code',
    zipCodePlaceholder: 'ZipCode',
    phone: 'Phone',
    phonePlaceholder: 'Phone',
    comments: 'Comments',
    moneygramInfo: 'Information on record will be used to send the moneygram payout',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    currency: 'Moneda',
    amount: 'Monto',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    firstName: 'Nombre',
    firstNamePlaceholder: 'Nombre',
    lastName: 'Apellido',
    lastNamePlaceholder: 'Apellido',
    country: 'País',
    countryPlaceholder: 'País',
    state: 'Estado',
    statePlaceholder: 'Estado',
    city: 'Ciudad',
    cityPlaceholder: 'Ciudad',
    address: 'Dirección',
    addressPlaceholder: 'Dirección',
    zipCode: 'Código Postal',
    zipCodePlaceholder: 'Código Postal',
    phone: 'Teléfono',
    phonePlaceholder: 'Teléfono',
    comments: 'Comentarios',
    moneygramInfo: 'La información registrada será usada para enviar el retiro por moneygram',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    currency: 'Moeda',
    amount: 'Valor',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    firstName: 'Nome',
    firstNamePlaceholder: 'Nome',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Sobrenome',
    country: 'País',
    countryPlaceholder: 'País',
    state: 'Estado',
    statePlaceholder: 'Estado',
    city: 'Cidade',
    cityPlaceholder: 'Cidade',
    address: 'Endereço',
    addressPlaceholder: 'Endereço',
    zipCode: 'CEP',
    zipCodePlaceholder: 'CEP',
    phone: 'Telefone',
    phonePlaceholder: 'Telefone',
    comments: 'Comentários',
    moneygramInfo: 'As informações registradas serão usadas para enviar o saque pelo moneygram',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
